// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    url: 'https://widget.staging.open-s.info',
    domainName: 'widget.staging.open-s.info',
  };
  
  export const YA_API_KEY_VALUE = 'af247072-d9d3-452e-b87f-7c7b50e2545c';
  export const G_MAPS_KEY_VALUE = 'AIzaSyCYHsbgD1odeOLUzPhVjMqxcuweCtG6NQc';
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
